/**
 * Reference URL classification.
 *
 * Uploaded photo references are stored as base64 `data:` URLs. Browsers
 * refuse to open a `data:` URL as a top-level page (anti-phishing), so a
 * `target="_blank"` link to one lands on a blank tab. These helpers let the
 * reference renderers show such images in-page instead of linking to them.
 *
 * Blackboard captures were saved with the base64 cut to 200 chars plus
 * "...", so they can never decode — treat those as non-viewable.
 */

const DATA_URL = /^data:/i;
const DATA_IMAGE_URL = /^data:image\//i;
const TRUNCATION_MARK = '...';

/** @param {unknown} url @returns {boolean} */
export function isDataUrl(url) {
  return typeof url === 'string' && DATA_URL.test(url);
}

/** A complete base64 image that can be shown in an <img>. @param {unknown} url @returns {boolean} */
export function isViewableInlineImage(url) {
  return typeof url === 'string' && DATA_IMAGE_URL.test(url) && !url.endsWith(TRUNCATION_MARK);
}

// http(s) or a same-site path only — never `javascript:` / `data:` / `lesson://`.
const OPENABLE = /^(https?:\/\/|\/(?!\/))/i;

/** A URL that can be opened as a normal link / new tab. @param {unknown} url @returns {boolean} */
export function isOpenableLink(url) {
  return typeof url === 'string' && OPENABLE.test(url.trim());
}
